module.exports = __webpack_public_path__ + "img/visa-dark.4057a981.svg";